var map = {
	"./OpenSans-Italic.ttf": 92025,
	"./OpenSans-Light.ttf": 61507,
	"./OpenSans-LightItalic.ttf": 59724,
	"./OpenSans-Medium.ttf": 49578,
	"./OpenSans-MediumItalic.ttf": 78058,
	"./OpenSans-Regular.ttf": 49060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72437;